import React, { PureComponent } from 'react';
import b from 'b_';

import './event-item-horizontal.css';

import { Event } from '@interfaces/outreach-entity';

const class_ = b.with('event-item-horizontal');

interface Props {
    entity: Event;
    isCompleted: boolean;
    dateInterval: string;
}

export default class EventItemHorizontal extends PureComponent<Props> {
    public render() {
        const { entity, dateInterval, isCompleted } = this.props;
        const { isPinned, image, title, description, link, place } = entity;
        const bottom = [dateInterval, place].filter(Boolean).join(', ');

        return (
            <div className={class_({ pinned: isPinned, completed: isCompleted })}>
                <a className={class_('image-wrap')} href={link}>
                    <img className={class_('image')} src={image || '/no-record.png'} />
                </a>

                <div className={class_('info')}>
                    <a className={class_('title')} href={link}>
                        {title}
                    </a>
                    <div className={class_('description')}>
                        {description}
                    </div>

                    <div className={class_('bottom')}>
                        {bottom}
                    </div>
                </div>
            </div>
        );
    }
}
